class NavMove{
    constructor(btn , content){
        this.btn = btn;
        this.content = content;
    }
    move() {
        const params = {};
        window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi , (str , key , value) => params[key] = value)
        if(params.id === '1') {
            this.btn[1].classList.remove('active')
            this.btn[0].classList.add('active')
        } else if(params.id === '2') {
            this.btn[0].classList.remove('active')
            this.btn[1].classList.add('active')
            this.content[0].style.display = 'none'
            this.content[1].style.display = 'block'
        }
        this.btn.forEach( (e) => {
            e.addEventListener('click' , (event) => {
                this.btn.forEach( (v) => v.classList.remove('active'))
                e.classList.add('active')
                const target = event.currentTarget.textContent;
                if(target === '이용약관') {
                    this.content[1].style.display = 'none'
                    this.content[0].style.display = 'block'
                } else {
                    this.content[0].style.display = 'none'
                    this.content[1].style.display = 'block'
                }
            })
        })
    }
}


const provision = new NavMove(
    document.querySelectorAll('.provision-nav-box button'),
    document.querySelectorAll('.provision-content .text-content-box > div'),
)
provision.move()